'use client';

import type { RefObject } from 'react';

import { MegaMenuDropdown, SimpleDropdown } from './HeaderDropdowns';
import type { DropdownPosition } from '../../types/header';
import type { NavItem } from '../../types/navigation';

interface HeaderActiveDropdownProps {
  dropdownPosition: DropdownPosition | null;
  dropdownRef: RefObject<HTMLDivElement | null>;
  openDropdown: string | null;
  openedItem: NavItem | null;
  onDropdownEnter: (key: string) => void;
  onDropdownLeave: () => void;
}

const HeaderActiveDropdown = ({
  dropdownPosition,
  dropdownRef,
  openDropdown,
  openedItem,
  onDropdownEnter,
  onDropdownLeave,
}: HeaderActiveDropdownProps) => {
  if (!openedItem || !openDropdown || !dropdownPosition) {
    return null;
  }

  const handleMouseEnter = () => onDropdownEnter(openDropdown);

  if (openedItem.megaMenu) {
    return (
      <MegaMenuDropdown
        dropdownRef={dropdownRef}
        megaMenu={openedItem.megaMenu}
        position={dropdownPosition}
        onMouseEnter={handleMouseEnter}
        onMouseLeave={onDropdownLeave}
      />
    );
  }

  return (
    <SimpleDropdown
      dropdownRef={dropdownRef}
      items={openedItem.dropdown || []}
      position={dropdownPosition}
      onMouseEnter={handleMouseEnter}
      onMouseLeave={onDropdownLeave}
    />
  );
};

export default HeaderActiveDropdown;
